module.exports = __webpack_public_path__ + "static/media/ice-skate.73d266ff.svg";